module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0026.jpg?v=02a13b05";